import PropTypes from 'prop-types';

export default function DrawerHeader({ open }) {
  return (
    <div
      className={`flex ${open ? 'justify-start px-5' : 'justify-center px-2'} py-4 items-center gap-3`}
      style={{ borderBottom: '1px solid rgba(255,255,255,0.06)', minHeight: 64 }}
    >
      <div
        className="w-9 h-9 rounded-xl flex items-center justify-center text-sm font-black shrink-0"
        style={{ background: 'linear-gradient(135deg, #DD6633, #ff8c5a)', color: '#fff', boxShadow: '0 4px 12px rgba(221,102,51,0.4)' }}
      >
        42K
      </div>
      {open && (
        <div>
          <div className="text-base font-black text-white leading-tight">42kicks</div>
          <div className="text-[10px] tracking-widest" style={{ color: 'rgba(255,255,255,0.4)' }}>ADMIN</div>
        </div>
      )}
    </div>
  );
}

DrawerHeader.propTypes = { open: PropTypes.bool };
